import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import _, { has } from 'lodash';
import { setLocationsQuery, promiseTimeout, getCurrentPage, hasToAndFromLocations } from '../../helpers';

/**
* -AddDestination-
* AddDestination component
**/
export default class AddDestination extends React.Component {

	state = {
		type: 'to',
		hasToAndFromLocations: false
	};

	geocodeLocation = (location) => {

		const { google } = this.props;

		return new Promise((resolve, reject) => {

			var geocoder = new google.maps.Geocoder();

			geocoder.geocode({ 'location': location }, function (results, status) {
				if (status === 'OK') {
					if (results[0]) {

						const title = results[0].formatted_address;

						resolve(title);

					} else {

						reject('No results found');
					}
				} else {

					reject('Geocoder failed due to: ' + status);
				}
			});
		});
	}

	updateOnRouteChange() {

		this.setState({
			text: (getCurrentPage() === 'route-planning') ? 'Add as location' : 'Plan journey to here',
			locationType: (getCurrentPage() === 'route-planning') ? 'multiple' : 'link',
		});
	}

	addDestination = _.debounce(() => {

		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: 'Click add destination',
		});

		const lat = this.state.lat;
		const lng = this.state.lng;
		let name = this.state.name;
		const type = this.state.type;

		this.setState({
			loading: true,
		});

		// Set location after geocode or timeout
		const finaliseLocation = () => {
			if (this.state.locationType === 'single') {

				this.props.setLocation(0, lat, lng, name);

				setLocationsQuery(this.props.locations);

			} else if (this.state.locationType === 'multiple') {
				this.props.addLocation(lat, lng, name, type);
				setLocationsQuery(this.props.locations);

				this.props.removeOverlay('sitewide');

			} else if (this.state.locationType === 'link') {

				this.props.setLocation(1, lat, lng, name);

				setLocationsQuery(this.props.locations, '/route-planning');
			}
		}

		// If we have a name, then set location, else attempt to geolocation
		if (name) {

			finaliseLocation();

		} else {

			// Attempt to get address from Reverse Geocode or timeout
			const geocodeLocation = promiseTimeout(2000, this.geocodeLocation({ lat, lng }));

			// Wait for the promise to get resolved
			geocodeLocation.then(response => {

				name = response;

				finaliseLocation();
			});

			// Wait for the promise to get rejected or timed out
			geocodeLocation.catch(error => {

				name = `User set: ${lat.toFixed(5)} | ${lng.toFixed(5)}`;

				finaliseLocation();
			});
		}

	}, 200);

	updateLocation = () => {

		let lat, lng, name;

		// From marker
		if (this.props.marker) {

			const position = this.props.marker.getPosition();
			lat = position.lat();
			lng = position.lng();
			name = this.props.marker.getTitle();

			// From position (rightclick)
		} else if (this.props.position) {

			const position = this.props.position;
			lat = position.lat;
			lng = position.lng;
			name = this.props.title;
		}

		this.setState({
			lat,
			lng,
			name
		});
	}

	componentDidMount() {

		this.updateOnRouteChange();

		this.updateLocation();

		this.state.hasToAndFromLocations = hasToAndFromLocations(this.props.locations);
	}

	componentDidUpdate(prevProps) {

		if (this.props.routes !== prevProps.routes) {

			this.updateOnRouteChange();
		}

		if (this.props.marker !== prevProps.marker) {

			this.updateLocation();
		}
	}

	handleTypeChange = (event) => {
		this.setState({ type: event.target.value });
	}

	render() {
		const { type, hasToAndFromLocations } = this.state;

		return (
			<div className={`map-overlay-addDestination isLoading-${this.state.loading}`}>
				<div className='map-overlay-options'>
					<label>
						<input
							type="radio"
							name="destinationType"
							value="from"
							checked={type === 'from'}
							onChange={this.handleTypeChange}
						/>
						From
					</label>
					<label>
						<input
							type="radio"
							name="destinationType"
							value="to"
							checked={type === 'to'}
							onChange={this.handleTypeChange}
						/>
						To
					</label>
					{hasToAndFromLocations && <label>
						<input
							type="radio"
							name="destinationType"
							value="waypoint"
							checked={type === 'waypoint'}
							onChange={this.handleTypeChange}
						/>
						Waypoint
					</label>}
				</div>

				<div>
					<a className="popup-addDestination" onClick={
						(e) => {
							e.preventDefault();
							this.addDestination();
						}
					}>
						{this.state.text}
					</a>
					<svg className="icon" aria-hidden="true"><use xlinkHref="#icon_plus_alt2" /></svg>
				</div>
			</div>
		)
	}
}

AddDestination.propTypes = {
	marker: PropTypes.object,
	position: PropTypes.object,
	title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/AddDestination.js